import RadioGroup from './component'

export default RadioGroup
